import React from 'react';
import SolutionDescription from './SolutionDescription';
import "./aboutussection.css";


const AboutUsSection = () => {
  return (
    <div className='aboutussection'>
      <div className='AboutUsSection_block1'>
        <div className='AboutUsSection_block2'>
          <SolutionDescription />
        </div>
        <div className='AboutUsSection_block3'>

          <div>
            <img src={"/img/home_page_marge_img_aboutus.png"} alt="Background" className='img_section' />

          </div>
        </div>
      </div>
    </div>

  );
};

export default AboutUsSection;

